const now = Date.now()
const endDate = new Date("21 Jan 2026 00:00:00 UTC+01:00").getTime()
const days = document.querySelector('#days .value')
const daysLabel = document.querySelector('#days .label')
const dayInMilliseconds = 86400000

const pad = (num) => {
    num = num.toString()
    return num.length < 2 ? "0" + num : num
}

const daysLeft = () => {
    const deltaTimeInMilliseconds = endDate - now
    const deltaTime = new Date(deltaTimeInMilliseconds)
    const daysNum = Math.floor(deltaTimeInMilliseconds / 86400000)

    if (daysNum == 1)
        daysLabel.textContent = 'Tag'

    if (deltaTime > 0)
        days.textContent = daysNum
}

daysLeft()
